export default {
    getAllBoxes: () => {
        return {
            url: '/fhe/boxes',
            method: 'GET'
        };
    },
    getBoxDetails: macAddress => {
        return {
            url: '/fhe/boxes/:macAddress',
            method: 'GET',
            route_params: {
                macAddress
            }
        };
    },
    autocompleteBoxMac: macAddr => {
        return {
            url: '/fhe/boxes/autocomplete',
            method: 'GET',
            get_params: {
                macAddr
            }
        };
    },
    dissociateBox: (boxeMac, homeId) => {
        return {
            url: '/fhe/boxes/:boxeMac/dissociate',
            method: 'POST',
            route_params: {
                boxeMac
            },
            post_params: {
                homeId
            }
        };
    },
    associateBox: (macAddress, homeId) => {
        return {
            url: '/fhe/boxes/:macAddress/associate',
            method: 'PATCH',
            route_params: {
                macAddress
            },
            patch_params: {
                homeId
            }
        };
    },
    updateBoxDetails: (boxMac, boxForm) => {
        return {
            url: '/fhe/boxes/:boxMac',
            method: 'PATCH',
            route_params: {
                boxMac
            },
            patch_params: {
                brand: boxForm.brand,
                installerId: boxForm.installerId
            }
        };
    },
    logClientInterfaceConnection: boxId => {
        return {
            url: '/fhe/clientInterfaceConnection/:boxId',
            method: 'GET',
            route_params: {
                boxId
            }
        };
    },
    boxSwap: swapData => {
        return {
            url: `/fhe/boxes/swap`,
            method: 'PATCH',
            post_params: swapData
        };
    }
};



// WEBPACK FOOTER //
// ./environments/fhe/data/Boxes/api.js